<template>
  <v-card
    class="mx-auto text-center"
    color="#394264"
    dark
    max-width="1200"
  >
    <v-card-text class="justify-space-between align-center">
      <v-sheet color="#3468AF">
        <v-sparkline
          :value="membos"
          color="rgba(255, 255, 255, .7)"
          height="150"
          padding="24"
          stroke-linecap="round"
          smooth
          :labels="meses"
          type="bar"
        >
          <template v-slot:label="item">
            {{ item.value }}
          </template>
        </v-sparkline>
      </v-sheet>
    </v-card-text>

    <v-card-text>
      <div class="text-h4 font-weight-thin">
        NOVOS MEMBROS MÊS
      </div>
    </v-card-text>

    <!-- <v-divider></v-divider>

    <v-card-actions class="justify-center">
      <v-btn
        block
        text
      >
        Go to Report
      </v-btn>
    </v-card-actions> -->
  </v-card>
</template>

<script>
import api from '../../../../plugins/api'
import Cookie from 'js-cookie'
import VueJwtDecode from 'vue-jwt-decode'
export default {
  data: () => ({
    value: [
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ],
    meses: [
      'Jan',
      'Fev',
      'Mar',
      'Abr',
      'Mai',
      'Jun',
      'Jul',
      'Ago',
      'Set',
      'Out',
      'Nov',
      'Dez'
    ],
    membos: []
  }),
  mounted () {
    this.chartDizimoMonths()
  },
  methods: {
    chartDizimoMonths () {
      const getToken = Cookie.get('token')
      const decriptToken = VueJwtDecode.decode(getToken)
      api.get('reports/chart-membros-months?idchurch=' + Number(decriptToken.id_church)).then((resp) => {
        resp.data.objeto.forEach(element => {
          this.value[element.mes] = element.total
        })
        this.membos = this.value
      }).catch(console.error())
    }
  }
}
</script>
